import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { SessionTimeoutService } from '../../services/session-timeout.service';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-session-timeout-dialog',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    DialogModule,
    ButtonModule,
    InputTextModule,
    PasswordModule
  ],
  template: `
    <p-dialog
      [(visible)]="visible"
      [modal]="true"
      [closable]="false"
      [closeOnEscape]="false"
      header="Session Timeout Warning"
      [style]="{ width: '450px' }"
    >
      <div class="flex flex-column gap-4">
        <div class="text-lg">
          Your session is about to expire. Would you like to continue working?
        </div>
        
        <div class="flex flex-column gap-2">
          <label for="password">Please enter your password to continue:</label>
          <p-password
            id="password"
            [(ngModel)]="password"
            [feedback]="false"
            [toggleMask]="true"
            placeholder="Enter your password"
          ></p-password>
          <small class="text-red-500" *ngIf="error">{{ error }}</small>
        </div>
      </div>
      
      <ng-template pTemplate="footer">
        <div class="flex gap-2 justify-content-end">
          <p-button
            label="Logout"
            severity="secondary"
            (onClick)="logout()"
          ></p-button>
          <p-button
            label="Continue Session"
            (onClick)="continueSession()"
            [loading]="loading"
          ></p-button>
        </div>
      </ng-template>
    </p-dialog>
  `
})
export class SessionTimeoutDialogComponent implements OnInit, OnDestroy {
  visible = false;
  password = '';
  error = '';
  loading = false;

  constructor(
    private sessionTimeoutService: SessionTimeoutService,
    private authService: AuthService,
    private router: Router
  ) {}

  ngOnInit() {
    this.sessionTimeoutService.showWarningDialog$.subscribe(
      show => {
        this.visible = show;
        if (show) {
          this.password = '';
          this.error = '';
        }
      }
    );
  }

  async continueSession() {
    if (!this.password) {
      this.error = 'Password is required';
      return;
    }

    this.loading = true;
    this.error = '';

    try {
      // Get the current user's username from the token
      const decodedToken = this.authService.decodeToken();
      const username = decodedToken?.username || decodedToken?.email || '';

      await this.authService.login({ 
        username, 
        password: this.password 
      }).toPromise();

      this.sessionTimeoutService.hideWarningDialog();
      this.password = '';
    } catch (error) {
      this.error = 'Invalid password';
    } finally {
      this.loading = false;
    }
  }

  logout() {
    this.authService.logout();
    this.router.navigate(['/login']);
  }

  ngOnDestroy() {
    this.sessionTimeoutService.hideWarningDialog();
  }
} 